module.exports = __webpack_public_path__ + "img/loading.eb181684.png";